export default __webpack_public_path__ + "static/tnfy-blog-random-991a21b8ebe2f2122a4624b9e5de1d9d.png";